<template>
  <div id="app">
    <keep-alive>
        <router-view :key="$route.fullPath" v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>

    <div class="headline-wrapper">
      <div class="description-hatching"></div>
      <div class="description-box">
        <div class="blog-headline"><img :src="headlineImage"></div>
        <div class="top-left-radius dark-radius"></div>
        <div class="top-right-radius dark-radius"></div>
        <div class="bottom-left-radius dark-radius"></div>
        <div class="bottom-right-radius dark-radius"></div>
      </div>
    </div>

    <div class="footer" v-if="$route.meta.showCopyRight">
      <span>naranzug.com 版权所有</span>
      <span><a href="http://www.beian.miit.gov.cn/" target="_blank">京ICP备14055015号-1</a></span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'App',
  mounted () {
    // // 创建cnzz统计js
    // const CNZZ_ID = 1279102210
    // const script = document.createElement('script')
    // script.src = `https://s4.cnzz.com/z_stat.php?id=${CNZZ_ID}&web_id=${CNZZ_ID}`
    // script.language = 'JavaScript'
    // document.body.appendChild(script)
  },
  data () {
    return {
      headlineImage: ('//' + this.$mediaHost + '/naranzug/wangzhan_jiegou/odzar_new.png')
    }
  },
  watch: {
    '$route': {
      handler (to, from) {
        setTimeout(() => { // 避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location
            let contentUrl = location.pathname + location.hash
            let refererUrl = '/'
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_trackPageview', contentUrl, refererUrl])
          }
        }, 300)
      },
      immediate: true // 首次进入页面即执行
    }
  },
  created () {
    console.log('App created ', this.$route)
    if (this.$route.meta.title) {
      document.title = this.$route.meta.title
    }
  }
}
</script>

<style>
body {
  margin: 0;
  background-color: #fff4da;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.container {
    margin: 0 auto;
    max-width: 1000px;
    position: relative;
    width: 90%;
}
.page-content {
  margin-top: 92px;
}
.headline-wrapper {
    min-height: 54px;
    position: relative;
    width: 100%;
}
.description-hatching {
    background: left top repeat url(//naranzug.ip008.com/wp-content/themes/timeturner/images/hatching.png);
    height: 16px;
    /* margin-top: -8px; */
    margin-top: -10px;
    position: absolute;
    top: 50%;
    left: 0;
    width: 100%;
}
.description-box {
    border-color: #357f87;
        display: table;
    margin: 0 auto;
    max-width: 80%;
    position: relative;
    width: auto;
    z-index: 10;
}
.portfolio-headline {
    border: 1px solid #fff4da;
    color: #0a0a0a;
    font-family: Amarante, "Times New Roman", serif;
    font-size: 30px;
    font-weight: normal;
    height: 51px;
    line-height: 50px;
    margin: 0;
    min-height: 50px;
    padding: 0 16px;
    position: relative;
    text-align: center;
    width: auto;
}
.portfolio-headline img {
  width: 160px;
}
.blog-headline, body .content-headline, body .read-more-button:hover, body .custom-button:hover, body input[type="submit"]:hover, body input[type="reset"]:hover {
    background-color: #4bb5c1 !important;
}
.blog-headline {
    max-width: 880px;
    border: 1px solid #fff4da;
    color: #0a0a0a;
    font-family: Amarante, "Times New Roman", serif;
    font-size: 30px;
    font-weight: normal;
    height: 110px;
    line-height: 110px;
    margin: 0;
    min-height: 50px;
    padding: 10px 28px;
    position: relative;
    text-align: center;
    width: auto;
}
img {
    height: auto;
    /* max-width: 100%; */
}
body .portfolio-headline {
    background-color: #4bb5c1;
}
.footer {
  font-size: 12px;
  margin-bottom: 2px;
}
.footer span {
  margin: 0 6px;
}
.footer a {
  text-decoration: none;
}
.dark-radius {
    background: #fff4da;
    height: 4px;
    position: absolute;
    width: 4px;
    z-index: 20;
}
.top-left-radius {
    -webkit-border-bottom-right-radius: 4px;
    -moz-border-radius-bottomright: 4px;
    border-bottom-right-radius: 4px;
    top: 1px;
    left: 1px;
}
.top-right-radius {
    -webkit-border-bottom-left-radius: 4px;
    -moz-border-radius-bottomleft: 4px;
    border-bottom-left-radius: 4px;
    top: 1px;
    right: 1px;
}
.bottom-left-radius {
    -webkit-border-top-right-radius: 4px;
    -moz-border-radius-topright: 4px;
    border-top-right-radius: 4px;
    top: 100%;
    left: 1px;
    margin-top: -5px;
}
.bottom-right-radius {
    -webkit-border-top-left-radius: 4px;
    -moz-border-radius-topleft: 4px;
    border-top-left-radius: 4px;
    top: 100%;
    right: 1px;
    margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue